import React from "react"
import ZdqConnectorStatus from "../../components/ZdqConnectorStatus"
import { AWS_RDS_POSTGRES } from "../../Constants"

function ZdqAwsRdsPostgresConnectorStatus() {
    return <ZdqConnectorStatus vendor={AWS_RDS_POSTGRES}></ZdqConnectorStatus>
}

export default ZdqAwsRdsPostgresConnectorStatus